var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4, _br, _br2, _br3, _text5, _path16, _path17, _rect5, _text6, _path18, _path19, _br4, _text7, _text8, _text9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "447px",
    height: "239px",
    viewBox: "-0.5 -0.5 447 239",
    content: "<mxfile modified=\"2019-02-17T15:24:56.768Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/72.0.3626.109 Safari/537.36\" etag=\"9FxZLUCXKqL2iOL9I1uN\" version=\"10.2.3\" type=\"device\"><diagram id=\"G6LgFVmxkW0KrgXp68bx\" name=\"Page-1\">7Zpfc9o4EMA/DTN3DzC2jA08BidpZ467Zi7tXfsobGF0EZZHFn/cT38rLBvbMgFSSDMlL4y0rNby/larlaDj+IvNB4GT+Z88JKyDrHDTcW47CA1GFnwqQZYL+t4gF0SChrnI3gke6XeihXpctKQhSWuKknMmaVIXBjyOSSBrMiwEX9fVZpzVn5rgiBiCxwAzU/ovDeVcS21vtPviI6HRXD96iPT7LXChrN8kneOQrysi567j+IJzmbcWG58w5bvCL/m4+z3flhMTJJbHDPgmkzXy8Jz98Zja3bsnPpn81XVzKyvMlvqF9WRlVniAhOAQ3eVCznnEY8zudtKx4Ms4JOoxFvTmcsGgaUPzPyJlppnipeQg2lmYcJ5ovfyZ6kF7302LUr4UAXnmhVDpWYhIwhdEigzGCcKwpKu6faxjIyr1yqEPnMKTkaXDGLkaoo5iezDouXUjEouISD1uhwEalYnsRFs4J4BCh0FBgCWqudhEain2Ehr2ViRNCUt7guBAclHHgxmNYmgH4GWivlsRISnE/gRPCXvgKZWUK4Upl5IvKgo3eqRUCMchTuclfj1PUCSb52malIoBTsPbRX+9W4F9LZpX1t7I3c+1xuNU53uHnX/QdXwpGY2JX+Ypq41AzZUVVO2ObyGOFjQNegFnywXojfPG52yrJgXOzoDHWAz20MDjtuCxHXQhPoM3kcXAfSL7Cp2u1Sv735S9nmt7heB2o5+Q97Jq74EICh5RkVBZS4fz4tnznWM30t2obiFPw0ayM+zYxW64z9CerHkjtqFaqiVKIX0mP7fPdxdTucGzZuTRmwi6nxYiZbbNGqhPjRFncMDQhXfWotK8VpCO1Vg8nt2sbY5GOTxo6tIw7WuH2dibR/2Xwzxo6tIwjyh6rwkmKurgH0VpGLo0SMcA6WPZ9QUOnoAMsj7g1CALBaqsAxMkpd/xdKugWOqqALTdcce9VfU0YExzotUDDiMzub+ITnBA4+jzlne3D5IZZcznTB2XYCJO6JJhqOSpFPyJVL4Zoqnjeec59Bgr1zIPPbbdUlYja39c/VBVbfcPU+PqTPOOrnle7ZvonFdFZ97r1NFNtpPIEVL2DrAB0Cuvd6oI2w61l0NoXjrUEX4keJW9I9y3V7alT+9VAQ4NgPdsSRU6AIlZBs5UbQUUHAjN3+59//cO8pjy9lRAK1KtTwkRUEZsVXweh9urJZjtjalq90rrqTovWzSGjynBoeqA38GlfB0S1ZhxsTAtHBFHZ6CF6rAGJqvWCz73Yqyu/jDv1VdP09NHX/i4L6s0T77waUy4WP7Hzquhf5kbImTeLPhZAKGCrE/vGdvI2EMzC7xqwkbmKeXKkkD9Ig6NRi++OxgcNHWmROD0n13Yp+pfKBGYJ6nx9nchtSvPBId92DK34pvbL8Wm/Y9qvpl0cf4CwG5Z+6OWtd/cTc639s0C4G/9k+kv5feyBC4WJjLPOa+adIvfBKtVMlTEqsTFv5z3zQs90/vD83gfuru/luR5bPf/HOfufw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 156 107.5 L 229.63 107.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 234.88 107.5 L 227.88 111 L 229.63 107.5 L 227.88 104 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 156 67.66 L 156 147.34 C 156 151.57 147.05 155 136 155 C 124.95 155 116 151.57 116 147.34 L 116 67.66 C 116 63.43 124.95 60 136 60 C 147.05 60 156 63.43 156 67.66 Z M 116 67.66 L 156 67.66 M 116 147.34 L 156 147.34 M 116 127.42 L 156 127.42 M 116 87.58 L 156 87.58 M 124 87.58 L 116 95.55 M 140 87.58 L 116 111.48 M 148 87.58 L 116 119.45 M 156 87.58 L 116 127.42 M 156 95.55 L 124 127.42 M 156 111.48 L 140 127.42 M 156 119.45 L 148 127.42 M 132 87.58 L 116 103.52 M 156 103.52 L 132 127.42",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 236 63 C 236 54.72 247.19 48 261 48 C 274.81 48 286 54.72 286 63 L 286 165 C 286 173.28 274.81 180 261 180 C 247.19 180 236 173.28 236 165 Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 236 74 L 286 74 M 236 84 L 286 84 M 236 94 L 286 94 M 236 104 L 286 104 M 236 114 L 286 114 M 236 124 L 286 124 M 236 134 L 286 134 M 236 144 L 286 144 M 236 154 L 286 154",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 17 109 L 7 109 L 106.63 109",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 111.88 109 L 104.88 112.5 L 106.63 109 L 104.88 105.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 281 57 L 354.63 57",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 359.88 57 L 352.88 60.5 L 354.63 57 L 352.88 53.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 287 91.5 L 360.63 91.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 365.88 91.5 L 358.88 95 L 360.63 91.5 L 358.88 88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 286 124.5 L 359.63 124.5",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.88 124.5 L 357.88 128 L 359.63 124.5 L 357.88 121 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 286 160 L 359.63 160",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.88 160 L 357.88 163.5 L 359.63 160 L 357.88 156.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 30,
    width: 110,
    height: 20,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.5,33.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 93,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Cat-Cracked Gas"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Cat-Cracked Gas")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 64,
    width: 130,
    height: 20,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.5,67.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 118,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Cat-Cracked Gasoline"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 59,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Cat-Cracked Gasoline")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 97.5,
    width: 150,
    height: 20,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.5,101.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 134,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Cat-Cracked Light Gasoil"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Cat-Cracked Light Gasoil")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 130,
    width: 160,
    height: 20,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.5,133.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 142,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Cat-Cracked Heavy Gasoil"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Cat-Cracked Heavy Gasoil")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5,6.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 195,
    height: 40,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Fluid Catalytic Cracking (FCC)", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Operating Conditions:", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "1. Catalysts in beads or powder form", _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 26,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 282 180 L 282 230 L 136 230 L 136 166.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 136 161.12 L 139.5 168.12 L 136 166.37 L 132.5 168.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 210,
    width: 60,
    height: 20,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.5,213.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 48,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Cycle Oil"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Cycle Oil")))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 281 230 L 326 230 L 354.63 230",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 359.88 230 L 352.88 233.5 L 354.63 230 L 352.88 226.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5,112.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 75,
    height: 26,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Bottoms from ", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), "ADU or VDU"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 19,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Bottoms from &lt;br&gt;ADU or VDU")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.5,157.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 42,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Reactor"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Reactor")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.5,167.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 64,
    height: 12,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, "Fractionator"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 12,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "Fractionator"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcc);
export default __webpack_public_path__ + "static/media/fcc.dbebde7066e57e26ae6fba969bc495bf.svg";
export { ForwardRef as ReactComponent };